import React, { memo } from 'react';
import Box from '@mui/material/Box';

type TProps = {
  children: React.ReactNode
};

const AppContainer = memo(({ children } : TProps) => (
  <Box sx={{ display: 'flex' }}>
    {children}
  </Box>
));
AppContainer.displayName = 'AppContainer';
export default AppContainer;
